import { getPartnerAccessToken } from '@leagueplatform/sso-util';

export function isEmpty(value: string) {
  return value == null || value.length === 0;
}

export function isNotEmpty(value: string) {
  return value !== '';
}

export const getPartnerToken = async () => {
  try {
    const partnerAccessToken = await getPartnerAccessToken('highmark');
    return { success: true, token: partnerAccessToken };
  } catch (error) {
    return { success: false, errMsg: error };
  }
};

export async function getAccessToken(
  url: string,
  partnerToken: string,
  ubk: string,
) {
  // const token = await getPartnerAccessToken('highmark');
  const requestOptions = {
    method: 'GET',
    headers: new Headers({
      Accept: 'application/json',
      Authorization: `Bearer ${partnerToken}`,
      ...(ubk && { brandUbk: ubk }),
    }),
  };
  try {
    // eslint-disable-next-line no-await-in-loop
    return await fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        return response.json();
      })
      .then((data) => data);
  } catch (error) {
    const errObj = {
      errMsg: error,
    };
    return errObj;
  }
}

export function formatDate(selectedDate: string) {
  return selectedDate.split('-').join('/');
}

export function isValidClaimNumber(val: string) {
  return val?.length > 7 && val?.length < 14;
}

export function isInvalidClaimNumber(val: string) {
  return val?.length < 9;
}

export function isNoSpace(val: string) {
  return /\s{2,}/g.test(val);
}

export function isContainDigitGreaterThanZero(medicareId: string) {
  const constantText = [...medicareId];
  const hasGreaterThan1 = constantText.some((val) => Number(val) > 0);
  return !hasGreaterThan1;
}

export function medicareValidation(medicareNumber: string) {
  const regex = /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{9,13}/gm;
  const regexAllZero = /^[a-zA-Z]*0*[a-zA-Z]*/;
  let error;
  if (regex.test(medicareNumber) && regexAllZero.test(medicareNumber)) {
    error = isContainDigitGreaterThanZero(medicareNumber);
  } else {
    error = true;
  }
  return error;
}

export function isAlphaNumberic(val: string) {
  return val.replace(/[^a-zA-Z0-9]+/gi, '');
}

export function isNumberOnly(val: string) {
  return val.replace(/[^0-9]+/gi, '');
}

export function isAlphaNumbericPlusSpace(val: string) {
  return val.replace(/[^a-zA-Z0-9 ]+/gi, '');
}

export function onlyCharacters(val: string) {
  return val.replace(/[^a-zA-Z ]+/gi, '');
}

export function isFutureDate(value: any) {
  const dateNow = new Date();
  const dateInput = new Date(formatDate(value));
  return dateNow.getTime() <= dateInput.getTime();
}

export function compareTwoDate(effectiveDate: any, terminationDate: any) {
  const startDate = new Date(formatDate(effectiveDate));
  const endDate = new Date(formatDate(terminationDate));
  return startDate.getTime() >= endDate.getTime();
}

export function isValidBin(val: string) {
  return val?.length === 6;
}

export function isValidPolicyNumber(val: string) {
  if (val === '') {
    return false;
  }
  isAlphaNumberic(val);
  return val?.length <= 17;
}

export function isValidLastName(val: string) {
  return val.replace(/[^a-zA-Z'-]+/gi, '');
}

export async function getPCNBINValidated(
  url: string,
  payload: any,
  partnerToken: string,
  ubk: string,
) {
  // const token = await getPartnerAccessToken('highmark');
  const reqUrl = `${url}${payload.payload.pcn}&bin=${payload.payload.bin}`;
  const requestOptions = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${partnerToken}`,
      Accept: 'application/json',
      ...(ubk && { brandUbk: ubk }),
    },
  };
  try {
    // eslint-disable-next-line no-await-in-loop
    return await fetch(reqUrl, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        return response.json();
      })
      .then((data) => data);
  } catch (error) {
    const errObj = {
      errMsg: error,
    };
    return errObj;
  }
}
